export const productCardImagesModalName = 'product-card-images';
